import React from "react";
import { useAuthentication } from 'global/Authentication';
import { MasterLayout } from "./MasterLayout";
import { BlankLayout } from "./BlankLayout";
import { IComponentContextMenu } from "model/Application";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import CRMWebResourceLayout from "./CRMWebResourceLayout";
import { useParams } from "react-router";
import { RouterParams } from "App";

interface IProps extends IComponentContextMenu {
  children: any;
}

const AutoSwitchLayout: React.FC<IProps> = ({ children }) => {
  const { isAuthenticated } = useAuthentication();
  const state = useSelector((state: RootState) => state);
  const { bcbs_opportunityproductid }: RouterParams = useParams();
  let Layout: any = BlankLayout;

  let isCRMEmbedded = !!bcbs_opportunityproductid

  if (isAuthenticated)
    Layout = MasterLayout;

  if (isCRMEmbedded)
    Layout = CRMWebResourceLayout

  return <Layout>{children}</Layout>;
}

export { AutoSwitchLayout };